import React from 'react'
import styled from 'styled-components'
import Colors from 'styles/Colors'
import media from 'styles/media'
import { Body3, HeadlineM, HeadlineS, Overline } from 'components/Text'
import { Paragraph } from 'components/richTextOptions'

const Press: React.FC<{}> = () => {
  return (
    <Wrapper>
      <List>
        <Item>
          <a
            target="_blank"
            href="https://www.assemblymag.com/articles/97511-new-software-makes-robots-easier-to-deploy"
          >
            <Subtitle>Assembly Magazine</Subtitle>
            <Paragraph>New software makes robots easier to deploy</Paragraph>
          </a>
        </Item>
        <Item>
          <a
            target="_blank"
            href="https://roboticsandautomationnews.com/2022/10/09/realtime-robotics-integrates-robot-motion-planning-and-control-software-with-siemens-process-simulate/55100/"
          >
            <Subtitle>Robotics & Automation</Subtitle>
            <Paragraph>
              Realtime Robotics integrates with Siemens Process Simulate
            </Paragraph>
          </a>
        </Item>
        <Item>
          <a
            target="_blank"
            href="https://www.automationworld.com/factory/robotics/article/22471740/automated-robot-path-planning-for-complex-applications"
          >
            <Subtitle>Automation World</Subtitle>
            <Paragraph>
              Automated robot path planning for complex applications
            </Paragraph>
          </a>
        </Item>
      </List>
      <List>
        <Item>
          <a
            target="_blank"
            href="https://www.businesswire.com/news/home/20221004005161/en/Merit-Awards-Announces-Winners-of-2022-Technology-Awards"
          >
            <Subtitle>Merit Awards</Subtitle>
            <Paragraph>
              Realtime Robotics takes Gold in 2022 Technology Awards: Robotics
            </Paragraph>
          </a>
        </Item>
        <Item>
          <a
            target="_blank"
            href="https://www.bizjournals.com/boston/inno/stories/awards/2022/09/22/2022-inno-on-fire-bostinno.html"
          >
            <Subtitle>BostInno</Subtitle>
            <Paragraph>
              Realtime is a recipient of the 2022 BostInno’s 50 on Fire:
              Robotics
            </Paragraph>
          </a>
        </Item>
        <Item>
          <a
            target="_blank"
            href="https://www.manufacturingtomorrow.com/news/2022/09/07/mitsubishi-electric-automation-inc-exhibiting-innovative-solutions-for-a-resilient-and-sustainable-future-at-imts-2022/19301/"
          >
            <Subtitle>Manufacturing Tomorrow</Subtitle>
            <Paragraph>
              Resilient and sustainable future showcased at IMTS 2022
            </Paragraph>
          </a>
        </Item>
      </List>
    </Wrapper>
  )
}

const Wrapper = styled.section`
  height: 548px;
  padding-top: 112px;
  position: relative;
  min-height: 935px;
  ${media.tabletLandscape} {
    min-height: 1200px;
    padding-top: 0;
  }
  ${media.tablet} {
    background: ${Colors.whiteSmoke};
    height: 264px;
    padding-top: 50px;
    min-height: 1000px;
  }
  ${media.mobile} {
    height: 414px;
    min-height: 1000px;
  }
`
const List = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 80%;
  margin-left: 96px;
  list-style-type: none;
  justify-content: space-between;
  @media screen and (max-width: 1255px) {
    justify-content: flex-start;
  }
  ${media.tabletLandscape} {
    float: left;
    width: 40%;
    padding-top: 120px;
    display: block;
  }
  ${media.tablet} {
    margin-left: 48px;
    display: block;
    margin-bottom: 50px;
  }
  ${media.mobile} {
    margin-left: 12px;
    display: block;
    max-width: calc(100% - 24px);
    float: none;
    width: 100%;
    padding-top: 40px;
  }
`

const Item = styled.span`
  width: 25%;
  font-size: 24px;
  text-transform: none;
  display: block;
  position: relative;
  &:nth-child(1),
  &:nth-child(2) {
    margin-bottom: 144px;
  }
  box-sizing: content-box;
  @media screen and (max-width: 1255px) {
    &:nth-child(odd) {
      margin-right: 60px;
    }
  }
  ${media.tabletLandscape} {
    font-size: 16px;
    width: 284px;
    &:nth-child(1),
    &:nth-child(2) {
      margin-bottom: 58px;
    }
    ::after {
      font-size: 16px;
    }
  }
  ${media.tablet} {
    color: white;
    font-weight: bold;
  }
  ${media.mobile} {
    margin-bottom: 48px;
    &:nth-child(1),
    &:nth-child(2) {
      margin-bottom: 48px;
    }
    &:nth-child(odd) {
      margin-right: 0;
    }
    max-width: 329px;
    width: unset;
  }
`
const Title = styled(HeadlineM)`
  margin-left: 96px;
  margin-bottom: 99px;
  ${media.tabletLandscape} {
    font-size: 54px;
  }
  ${media.mobile} {
    font-size: 36px;
    margin-top: 15px;
    margin-left: 12px;
  }
`

const Subtitle = styled(HeadlineS)`
  margin-bottom: 24px;
  font-family: 'Maison Neue';
  font-style: normal;
  font-weight: 500;
  font-size: 36px;
  line-height: 36px;
  letter-spacing: 0.0015em;
`
const Label = styled(Overline)`
  color: black;
  margin-bottom: 1vw;
  ::after {
    color: ${Colors.neptune};
    top: 0;
  }
  ${media.fullWidth} {
    font-size: 0.8vw;
  }
`

export default Press
